module.exports = __webpack_public_path__ + "static/media/more.b02c1da7.svg";